import { addDays, addMonths, addYears, format } from 'date-fns';

export const endTrial = (trialUnit: string, trialLength: number) => {
  if (trialUnit.includes('d')) {
    const dateEnd = addDays(new Date(), trialLength);

    return format(dateEnd, 'MMMM d, yyyy');
  }

  if (trialUnit.includes('m')) {
    const dateEnd = addMonths(new Date(), trialLength);

    return format(dateEnd, 'MMMM d, yyyy');
  }

  if (trialUnit.includes('y')) {
    const dateEnd = addYears(new Date(), trialLength);

    return format(dateEnd, 'MMMM d, yyyy');
  }
};

export const getParamByKey = (key: string) =>
  new URLSearchParams(document.location.search).get(key);

export function filterFalsyValues(object: Record<string, any>) {
  try {
    const keys = Object.keys(object);
    keys.forEach(key => {
      if (object[key] == null || object[key] === '') {
        delete object[key];
      }
    });
    return object;
  } catch (e) {
    console.error('[removeFalsyValuesFromObject error]: ', e);
  }
  return object;
}

export const delay = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const getSubscriptionName = (name: string | null | undefined) => {
  switch (true) {
    case name?.includes('3month'): {
      return '3-Month Plan';
    }
    default: {
      return 'Weekly Plan';
    }
  }
};

export const getSubscriptionInfo = (plan_code: string | undefined | null) => {
  switch (true) {
    case plan_code?.includes('premium_one_month'): {
      return {
        name: 'Premium Plan',
        price: 13.99,
        status: 'Premium',
        billingPeriod: 'Every 1 month',
      };
    }
    case plan_code?.includes('gift_one_month'): {
      return {
        name: 'Gift Plan',
        price: 19.99,
        status: 'Gift',
        billingPeriod: 'Every 1 month',
      };
    }
    case plan_code?.includes('mytraits_3m4800_3m4900'): {
      return {
        name: '3-Month Plan',
        price: 49.0,
        status: 'Premium',
        billingPeriod: 'Every 3 month',
      };
    }
    case plan_code?.includes('mytraits_3m4400_3m4900'): {
      return {
        name: '3-Month Plan',
        price: 49.0,
        status: 'Premium',
        billingPeriod: 'Every 3 month',
      };
    }
    case plan_code?.includes('mytraits_3m4800_3m4999'): {
      return {
        name: '3-Month Plan',
        price: 49.99,
        status: 'Premium',
        billingPeriod: 'Every 3 month',
      };
    }
    case plan_code?.includes('mytraits_3d5_7d2499'): {
      return {
        name: 'Weekly Plan',
        price: 5,
        status: 'Trial',
        billingPeriod: 'Every week',
      };
    }
    case plan_code?.includes('mytraits_1w1499'): {
      return {
        name: '1-Week Plan',
        price: 14.99,
        status: 'Premium',
        billingPeriod: 'Every week',
      };
    }
    case plan_code?.includes('mytraits_1y119'): {
      return {
        name: '12-Month Plan',
        price: 239.99,
        status: 'Premium',
        billingPeriod: 'Every year',
      };
    }
    case plan_code?.includes('mytraits_1m3999'): {
      return {
        name: 'Monthly Plan',
        price: 39.99,
        status: 'Premium',
        billingPeriod: 'Every 1 month',
      };
    }
    case plan_code?.includes('mytraits_2m3999'): {
      return {
        name: '2-Month Plan',
        price: 39.99,
        status: 'Premium',
        billingPeriod: 'Every 2 months',
      };
    }

    default: {
      return {
        name: 'Weekly Plan',
        price: 1,
        status: 'Trial',
        billingPeriod: 'Every week',
      };
    }
  }
};

export function serializeError(error: any): string {
  if (error === null || error === undefined) {
    return 'Unknown error';
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message || error.name || 'Error occurred';
  }

  if (typeof error === 'object') {
    // Try to extract meaningful error information
    if (error.message) {
      return String(error.message);
    }

    if (error.error) {
      return serializeError(error.error);
    }

    if (error.statusText) {
      return String(error.statusText);
    }

    if (error.status) {
      return `HTTP ${error.status}`;
    }

    // If it's a response object, try to extract error details
    if (error.data && typeof error.data === 'object') {
      if (error.data.message) {
        return String(error.data.message);
      }
      if (error.data.error) {
        return serializeError(error.data.error);
      }
    }

    // Last resort: try to stringify safely
    try {
      const serialized = JSON.stringify(error);
      return serialized.length > 200
        ? serialized.substring(0, 200) + '...'
        : serialized;
    } catch {
      return 'Unable to serialize error object';
    }
  }

  return String(error);
}
